export enum PaymentType {
  CREDIT = 'debitCreditCard',
  CHECKING = 'Checking',
  SAVINGS = 'Savings',
}

export enum PaymentAmountType {
  TOTAL_DUE = 'TOTAL_DUE',
  FULL = 'FULL',
  ANOTHER_AMOUNT = 'ANOTHER_AMOUNT',
  NO_PAYMENT = 'NO_PAYMENT',
}

export enum PaymentAmountTypeLabels {
  TOTAL_DUE = 'Minimum due',
  FULL = 'Pay in full',
  ANOTHER_AMOUNT = 'Pay another amount',
  NO_PAYMENT = 'No payment',
}

export enum StatusType {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
}

export enum EValueStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  NOTENROLLED = 'NOTENROLLED',
}
